
export const dialogStatusConstant = {
  create: 'create',
  update: 'update'
}

export const statusType = {
  0: 'success',
  1: 'warning'
}

// 考试类型
export const examType = {
  0: '练习',
  1: '考试',
  2: '问卷',
  3: '面试'
}

// 题目类型
export const subjectType = {
  0: '单选题',
  1: '简答题',
  2: '判断题',
  3: '多选题'
}

export const subjectTypeTag = {
  0: 'success',
  1: 'info',
  2: 'warning',
  3: 'default'
}


export const userTypeMap = [{
  value: 1,
  label: '学生'
}, {
  value: 2,
  label: '老师'
}, {
  value: 3,
  label: '讲师'
}]


// WEBPACK FOOTER //
// ./src/utils/constant.js